/**
 * Trim trailing zeros from numeric string
 * "123.00" -> "123"
 * "45.500" -> "45.5"
 * "-10.0" -> "-10"
 * "abc" -> "abc" (non-numeric, unchanged)
 */
export const trimTrailingZeros = (value: string): string => {
  const num = parseFloat(value);

  if (isNaN(num)) {
    return value; // Not a number, return as-is
  }

  // Convert back to string to remove trailing zeros
  return String(num);
};
